import {
  GlobalEvents,
  SnippetElement,
  Theme,
  defineElement,
  globalOn,
  liquidValue,
  on,
  param,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-BMSK74LT.js";

// src/snippets/util-product-form/util-product-form.ts
var UtilProductForm = class extends SnippetElement {
  get form() {
    return this.querySelector(`#${this.formId}`);
  }
  get formData() {
    if (this.form === null || this.form === void 0)
      return;
    return new FormData(this.form);
  }
  get formObj() {
    if (this.formData === null || this.formData === void 0)
      return;
    return Object.fromEntries(this.formData);
  }
  get currentVariant() {
    if (this.formObj === null || this.formObj === void 0)
      return;
    const obj = this.formObj;
    return this.variants.find((v) => {
      return v.option1 == obj.option1 && v.option2 == obj.option2 && v.option3 == obj.option3;
    });
  }
  submit(form, evt, emitEvents = true) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      evt.preventDefault();
      if (this.formData === null || this.formData === void 0) {
        console.error("Form data is null or undefined");
        return;
      }
      (_a = this.addToCartBtn) == null ? void 0 : _a.setAttribute("loading", "");
      const addons = this.formData.getAll("addons").filter((a) => a !== "" && typeof a === "string");
      const pfandAddonData = this.formData.get("_pfandAddon");
      const pfandAddon = [{
        variantId: pfandAddonData,
        quantityPerQuantity: 1
      }];
      const formData = this.formData;
      formData.delete("_pfandAddon");
      formData.set("properties[_pfandAddon]", JSON.stringify(pfandAddon));
      const unique = (_c = (_b = formData.get("id")) == null ? void 0 : _b.toString()) != null ? _c : "000";
      formData.set("properties[_unique]", unique);
      const res = yield fetch(this.cartUrl, {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body: formData
      }).then((res2) => __async(this, null, function* () {
        return yield res2.json();
      }));
      if (res.status === 422) {
        this.errorOutputs.forEach((e) => {
          e.show(res.description);
        });
      } else {
        this.errorOutputs.forEach((e) => {
          e.hide();
        });
        const stripIdentifier = (s) => s.replace(/\$\$.*$/, "");
        const addonItems = addons.map((a) => {
          var _a2, _b2, _c2, _d2;
          return {
            id: parseInt(stripIdentifier(a)),
            quantity: parseInt((_a2 = formData.get("quantity")) != null ? _a2 : "1"),
            properties: {
              _unique: unique,
              _type: (_b2 = formData.get(`type--${a}`)) != null ? _b2 : "addon",
              _custom: (_c2 = formData.get(`custom--${a}`)) != null ? _c2 : "",
              Text: (_d2 = formData.get(`text--${a}`)) != null ? _d2 : void 0
            }
          };
        });
        addonItems.length > 0 && (yield Theme.Cart.addItem(...addonItems));
        if (emitEvents) {
          Theme.Cart.emit("updated");
          GlobalEvents.emit("cart:open");
        }
      }
      (_d = this.addToCartBtn) == null ? void 0 : _d.removeAttribute("loading");
    });
  }
  updateSelectedVariant(_, event) {
    var _a, _b, _c, _d;
    if (this.currentVariant || event.detail != null) {
      const id = (_b = event.detail) != null ? _b : (_a = this.currentVariant) == null ? void 0 : _a.id;
      this.form.elements.namedItem("id").value = id.toString();
      const url = new URL(window.location.href);
      url.searchParams.set("variant", id.toString());
      window.history.replaceState(null, "", url);
      GlobalEvents.emit("product:variantChanged", { id });
    } else if (((_d = (_c = this.form) == null ? void 0 : _c.dataset) == null ? void 0 : _d.isMain) === "true") {
      const prefferedVariant = this.variants.find((v) => v.option1 === this.formObj.option1 && v.option2 === this.formObj.option2);
      if (prefferedVariant) {
        const url2 = new URL(window.location.href);
        url2.searchParams.set("variant", prefferedVariant.id.toString());
        window.history.replaceState(null, "", url2);
        location.reload();
      }
      const firstVariant = this.variants.find((v) => v.option1 === this.formObj.option1);
      if (!firstVariant) {
        throw new Error("No matching variant found");
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", firstVariant.id.toString());
      window.history.replaceState(null, "", url);
      location.reload();
    }
  }
};
__decorateClass([
  param("form_id")
], UtilProductForm.prototype, "formId", 2);
__decorateClass([
  liquidValue("routes.cart_add_url")
], UtilProductForm.prototype, "cartUrl", 2);
__decorateClass([
  liquidValue("product.variants")
], UtilProductForm.prototype, "variants", 2);
__decorateClass([
  queryAll("[data-form-error]")
], UtilProductForm.prototype, "errorOutputs", 2);
__decorateClass([
  query("[data-add-to-cart]")
], UtilProductForm.prototype, "addToCartBtn", 2);
__decorateClass([
  on("submit", "form")
], UtilProductForm.prototype, "submit", 1);
__decorateClass([
  globalOn("form:changeOption")
], UtilProductForm.prototype, "updateSelectedVariant", 1);
UtilProductForm = __decorateClass([
  defineElement("util-product-form")
], UtilProductForm);
export {
  UtilProductForm
};
